import * as React from "react";
import * as ReactDOM from "react-dom";
import AppPage from "./page/App";

//Entrance of WebApp
ReactDOM.render(<AppPage />, document.getElementById("widget-data-manager-ui"));
